
import { graphql, gqlRequest } from '@client/shared/graphql';
import { type ResultOf } from 'gql.tada';
import type { Role, NotificationSettings } from '@shared/user';


export type Viewer = Omit<ResultOf<typeof ViewerQuery>['viewer'], 'roles'> & {
  readonly roles: readonly Role[];
};

function toViewer(viewer: ResultOf<typeof ViewerQuery>['viewer']): Viewer {
  return { ...viewer, roles: viewer.roles as Role[] };
}

export const ViewerQuery = graphql(`
  query Viewer {
    viewer {
      id
      name
      email
      roles
      tutorialDismissedAt
      notificationSettings {
        listingAdded
        bookingCreated
        listingUpdated
      }
    }
  }
`);

export const VIEWER_QUERY_KEY = ['viewer'] as const;

export async function fetchViewer(signal?: AbortSignal): Promise<Viewer> {
  const data = await gqlRequest(ViewerQuery, {}, { signal });
  return toViewer(data.viewer);
}

export const UpdateMyProfileMutation = graphql(`
  mutation UpdateMyProfile($name: String!) {
    updateMyProfile(name: $name) {
      id
      name
      email
      roles
      tutorialDismissedAt
      notificationSettings {
        listingAdded
        bookingCreated
        listingUpdated
      }
    }
  }
`);

export async function updateMyProfile(variables: { name: string }): Promise<Viewer> {
  const data = await gqlRequest(UpdateMyProfileMutation, variables);
  return toViewer(data.updateMyProfile);
}


export const UpdateMyNotificationSettingsMutation = graphql(`
  mutation UpdateMyNotificationSettings($input: NotificationSettingsInput!) {
    updateMyNotificationSettings(input: $input) {
      id
      name
      email
      roles
      tutorialDismissedAt
      notificationSettings {
        listingAdded
        bookingCreated
        listingUpdated
      }
    }
  }
`);

export async function updateMyNotificationSettings(
  input: NotificationSettings,
): Promise<Viewer> {
  const data = await gqlRequest(UpdateMyNotificationSettingsMutation, { input });
  return toViewer(data.updateMyNotificationSettings);
}
